export const REFETCH_INTERVAL_MS = 10_000
export const REPORT_POLL_INTERVAL_MS = 5_000
export const DELIVERY_POLL_INTERVAL_MS = 2_000

// Delay before re-invalidating queries that depend on an async backend cascade
// (Kafka consumer, post-update worker, etc.) finishing after the mutation returns.
export const ASYNC_CASCADE_REFETCH_DELAY_MS = 3_500

export const BULK_MUTATION_CONCURRENCY = 10

// ListAssessmentQuestionnaires rejects more than this many ids
// (maxAssessmentQuestionnairesBatchSize in services/questionnaire/server.go).
export const ASSESSMENT_QUESTIONNAIRES_BATCH_SIZE = 100

// A questionnaire pod's database pool is 10 connections. Three calls at once leave the rest
// for other reads on that pod.
export const ASSESSMENT_QUESTIONNAIRES_MAX_CONCURRENT_BATCHES = 3

// One paint, so the rows AG Grid mounts together share a request.
export const ASSESSMENT_QUESTIONNAIRES_BATCH_WINDOW_MS = 20

// Sort and CSV reuse rows the cells already loaded. Same window the old per-row sort used.
export const ASSESSMENT_QUESTIONNAIRES_BULK_STALE_TIME_MS = 5 * 60_000

// Two characters is a real company search — LG, HP, GE, BP, 3M. The server skips the
// product lookup below 3 chars (its trigram index can't serve a leading wildcard that
// short) but still answers with companies.
export const AUTOCOMPLETE_MIN_SEARCH_LEN = 2

export const DEFAULT_TOP_MODEL_PROVIDERS_LIMIT = 10
